@use '../../styling/colors.scss' as *;

.Sidebar {
  position: relative;
  background: $color-secondary-purple;
  height: 100%;

  .collapseButtonWrapper {
    position: absolute;
    bottom: 20px;
    right: 0;
    transform: translateX(50%);
    z-index: 1;
  }
}
